// @flow

import { pipe, tap } from 'wonka';
import type { ExchangeInput, ExchangeIO } from 'urql';

// eslint-disable-next-line import/prefer-default-export
export class InitialPageViewMonitorExchange {
  resolvers: { [string]: () => void };
  currentPvid: string | null;
  currentPvPromise: Promise<void>;
  currentPvResolver: () => void;
  promises: Promise<void>[];
  collectedResolver: null | (() => void);
  collectedCallback: null | IdleCallbackID;

  constructor(initialPvid: string | null) {
    this.currentPvid = initialPvid;
    this.resolvers = {};
    this.collectedResolver = null;
    this.reset();
  }

  reset() {
    this.currentPvPromise = new Promise(resolve => {
      this.currentPvResolver = resolve;
    });
    this.collectedCallback = null;
    this.promises = [
      new Promise(resolve => {
        this.collectedResolver = () => {
          this.collectedResolver = null;
          resolve();
        };
      }),
    ];
  }

  allQueriesResolvedForPageView(newPvid: string) {
    if (this.currentPvid !== newPvid) {
      this.currentPvResolver();
      this.currentPvid = newPvid;
      this.reset();
    }
    return Promise.race([Promise.all(this.promises), this.currentPvPromise]);
  }

  exchange({ forward }: ExchangeInput): ExchangeIO {
    return ops$ =>
      pipe(
        ops$,
        tap(op => {
          if (this.collectedResolver && !this.collectedCallback) {
            const resolver = this.collectedResolver;
            this.collectedCallback = requestIdleCallback(resolver);
          }
          if (!(op.key in this.resolvers)) {
            this.promises.push(
              new Promise(resolve => {
                this.resolvers[op.key] = resolve;
              }),
            );
          }
        }),
        forward,
        tap(result => {
          this.resolvers[result.operation.key]();
        }),
      );
  }
}
